import * as AnalyticsApi from '@/api/analytics';
import { RAW_EVENT_NAMES } from '@/constants/analytics';

/**
 * @param {string | undefined | null} userId
 * @param {object} params
 * @param {string} params.contentId
 * @param {object | undefined} options
 * @param {string} options.forceReferrer
 */
async function sendContentVisitEvent(userId, params, options) {
  const { contentId } = params;

  if (!userId || !contentId) {
    return;
  }

  await AnalyticsApi.pushEvent(userId, RAW_EVENT_NAMES.CONTENT_VISIT, {
    contentId,
  }, options?.forceReferrer);
}

export default sendContentVisitEvent;
